import { observer } from "mobx-react-lite";
import {
  MDSButton,
  MDSButtonSlotName,
  MDSIcon,
  MDSIconKind,
  MDSTooltip,
  MDSTooltipPlacement,
} from "@/mds";

interface NoteVersionRestoreButtonProps {
  onRestore: () => void;
  isEnabled: boolean;
  isLoading?: boolean;
  versionLabel: string;
}

export const NoteVersionRestoreButton = observer<NoteVersionRestoreButtonProps>(
  function NoteVersionRestoreButton({ onRestore, isEnabled, isLoading, versionLabel }) {
    const button = (
      <MDSButton onClick={onRestore} isDisabled={!isEnabled} isLoading={isLoading}>
        <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.History} />
        Restore {versionLabel}
      </MDSButton>
    );

    if (!isEnabled) {
      return (
        <MDSTooltip
          config={{
            label: "This is the latest version already",
            placement: MDSTooltipPlacement.Top,
          }}
        >
          {button}
        </MDSTooltip>
      );
    }

    return button;
  }
);
